function getDayAndMonthAfter(days) {
  var today = new Date();
  var futureDate = new Date(today);
  futureDate.setDate(today.getDate() + days);
  var dayNumber = futureDate.getDate();
  var monthName = futureDate.toLocaleString('en-US', {
    month: 'short'
  });
  return {
    dayNumber: dayNumber,
    monthName: monthName
  };
}
// Get day and month after 7 days
var after7Days = getDayAndMonthAfter(7);
//console.log(after7Days.dayNumber, after7Days.monthName);
// Get day and month after 9 days
var after9Days = getDayAndMonthAfter(9);
//console.log(after9Days.dayNumber, after9Days.monthName);
setTimeout(function () {
  if (document.getElementById('estimateDay')) {
    if (after7Days.monthName != after9Days.monthName) {
      document.getElementById('estimateDay').innerHTML = after7Days.monthName + " " + after7Days.dayNumber + "-" + after9Days.monthName + " " + after9Days.dayNumber;
    } else {
      document.getElementById('estimateDay').innerHTML = after7Days.monthName + " " + after7Days.dayNumber + "-" + after9Days.dayNumber;
    }
  }
}, 500);